<template>
  <popup-slot>
    <quiz-found-message />
    <quiz-card />
    <quiz-number />
    <quiz-point-name />
    <quiz-url />
    <quiz-description />
    <quiz-hints />

    <button-to-Answer />
    <button-close />
  </popup-slot>
</template>

<script>
import MixinLocale from '@/components/MixinLocale'
import QuizFoundMessage from '@/components/PopupQuiz/FoundMessage'
import QuizCard from '@/components/PopupQuiz/Card'
import QuizNumber from '@/components/PopupQuiz/Number'
import QuizPointName from '@/components/PopupQuiz/PointName'
import QuizUrl from '@/components/PopupQuiz/Url'
import QuizDescription from '@/components/PopupQuiz/Description'
import QuizHints from '@/components/PopupQuiz/Hints'
import ButtonToAnswer from '@/components/PopupQuiz/ButtonToAnswer'
import ButtonClose from '@/components/PopupQuiz/ButtonClose'
import PopupSlot from '@/components/PopupQuiz/Slot'

export default {
  mixins: [
    MixinLocale
  ],

  components: {
    QuizFoundMessage,
    QuizCard,
    QuizNumber,
    QuizPointName,
    QuizUrl,
    QuizDescription,
    QuizHints,
    ButtonToAnswer,
    ButtonClose,
    PopupSlot
  }
}
</script>
